import React from "react";
import './atf.scss';
import Typewriter from "../Typewriter/Typewriter";
import ScrollIntoView from 'react-scroll-into-view';

const ATF = () => {
    return(
        <section className="atf-wrap">
            <header>
                <div className="head-wrap">
                    <div className="grid">
                        <ul>
                            <li>
                                <ScrollIntoView selector="#about">
                                    <button>About</button>
                                </ScrollIntoView>
                            </li>
                            <li>
                                <ScrollIntoView selector="#skills">
                                    <button>Skills</button>
                                </ScrollIntoView>
                            </li>
                            <li>
                                <ScrollIntoView selector="#career">
                                    <button>Career</button>
                                </ScrollIntoView>
                            </li>
                            <li>
                                <ScrollIntoView selector="#contact-me">
                                    <button>Contact Me</button>
                                </ScrollIntoView>
                            </li>
                        </ul>
                    </div>
                </div>
            </header>
            <div className="first-wrap">
                <div className="grid">
                    <div className="after-wrap">
                        <div className="cent-wrap">
                            <img src="images/plane.gif" alt="plane-gif" />
                            <h1>Tejas Nashikkar</h1>
                            <h2 className="line2">I am a <Typewriter /></h2>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ATF;